export default __webpack_public_path__ + "static/tiles-8-1cab247409f9405bdc3813573e2a8040.webp";